import React from 'react';
import { StreamingPlatform } from '../../types/streaming';

interface StreamStatsProps {
  viewerCount: number;
  likeCount: number;
  platform: StreamingPlatform | 'none';
  connectedUsername?: string;
}

const platformColors: Record<StreamingPlatform | 'none', string> = {
  tiktok: '#FF0050',
  youtube: '#FF0000',
  twitch: '#9146FF',
  none: '#666666'
};

const platformIcons: Record<StreamingPlatform | 'none', string> = {
  tiktok: '/vectors/tik-tok.svg',
  youtube: '/vectors/youtube.svg',
  twitch: '/vectors/twitch.svg',
  none: ''
};

export const StreamStats: React.FC<StreamStatsProps> = ({
  viewerCount,
  likeCount,
  platform,
  connectedUsername
}) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  if (platform === 'none') {
    return (
      <div className="bg-gray-800 rounded-xl p-4">
        <div className="text-center text-gray-400">
          <span className="text-2xl mb-2 block">📡</span>
          <p className="text-sm">Not connected to any stream</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-3">
        {/* Viewers */}
        <div className="bg-gray-900/50 rounded-lg p-2">
          <div className="flex items-center gap-1.5 mb-0.5">
            <svg className="w-3 h-3 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
              <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
            </svg>
            <span className="text-xs text-gray-400" style={{ fontSize: '10px' }}>Viewers</span>
          </div>
          <p className="text-base font-bold text-white">{formatNumber(viewerCount)}</p>
        </div>

        {/* Likes */}
        <div className="bg-gray-900/50 rounded-lg p-2">
          <div className="flex items-center gap-1.5 mb-0.5">
            <svg className="w-3 h-3 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
            </svg>
            <span className="text-xs text-gray-400" style={{ fontSize: '10px' }}>Likes</span>
          </div>
          <p className="text-base font-bold text-white">{formatNumber(likeCount)}</p>
        </div>
      </div>
    </div>
  );
};

export default StreamStats;

